import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Header from '../../components/Header';
import MenuBox from '../../components/MenuBox';
import { isAuthenticated } from '../../auth/Auth';

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    account: state.accounts.account,
    name: state.loginInfo.name
  })),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
    }
  })
);

const Main = enhance(({ classes, account, name, handleRedirect }) => {
  const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
  const isReleased =
    account && account.accountStatus && account.accountStatus.status === true;

  // check if is account shop
  if (!(isShop && isReleased)) {
    handleRedirect('/shops');
  }
  return (
    <div className={classes.root}>
      <Header name={name} />
      <div>download qr</div>
      <MenuBox account={account} />
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
